export const SCREEN_ID_REGEX = new RegExp('^[A-Za-z0-9_]+$');
export const EMAIL_REGEX = /^[\w!#$%&'*+=?`{|}~^-]+(?:\.[\w!#$%&'*+=?`{|}~^-]+)*@(?:[a-zA-z0-9-]+\.)+[A-za-z]{2,10}$/;
export const PASSWORD_REGEX = /^[a-zA-Z\d$#@!%^&*?]{6,12}$/;
export const US_ZIPCODE_MATCH_REGEXP = /^\d{5}(-\d{4})?$/;
